import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
} from "@reduxjs/toolkit";
import BreadcrumbReducer from "./reducers/BreadcrumbSlice";
import LoaderReducer from "./reducers/LoaderSlice";
import PatientReducer from "./reducers/PatientSlice";
import PractionerRoleIdsReducer from "./reducers/PractionerRoleIdsSlice";
import UserReducer from "./reducers/UserSlice";
import authUserId from "./reducers/AuthAshaDetailsSlice";

import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import PersistSlice from "./reducers/PersistSlice";
import ScreeningSlice from "./reducers/ScreeningSlice";
import UserConfigReducer from "./reducers/UserConfigSlice";

const rootReducer = combineReducers({
  breadcrumb: BreadcrumbReducer,
  loader: LoaderReducer,
  patientDetails: PatientReducer,
  practionerRoleIds: PractionerRoleIdsReducer,
  userDetails: UserReducer,
  persistDetails: PersistSlice,
  ashaAuthDetails: authUserId,
  screeningStatus: ScreeningSlice,
  userConfigDetails: UserConfigReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["persistDetails"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
